document.addEventListener("turbolinks:load", () => {
  window.tarteaucitronForceLanguage = 'fr';
  window.tarteaucitronForceExpire = 180;
  /*global tarteaucitron */
  window.tarteaucitronCustomText = {

  "middleBarHead": "Vos paramètres de cookies",
  "adblock": "Bonjour! Ce site joue la transparence et vous donne le choix des services tiers à activer.",
  "adblock_call": "Merci de désactiver votre adblocker pour commencer la personnalisation.",
  "reload": "Recharger la page",

  "alertBigScroll": "En continuant de défiler,",
  "alertBigClick": "En poursuivant votre navigation,",
  "alertBig": "vous acceptez l'utilisation de services tiers pouvant installer des cookies",

  "alertBigPrivacy": "La Caisse d’Epargne et ses partenaires utilisent des cookies nécessaires ayant pour finalité exclusive de permettre ou\
  faciliter la communication par voie électronique ou strictement nécessaires à la fourniture d'un service de\
  communication en ligne à la demande expresse des utilisateurs ainsi que pour mesurer son audience, analyser et\
  optimiser ses performances, suivre la navigation sur le site, réaliser des états statistiques, lutter contre les logiciels\
  automatiques et semis automatiques malveillants et visualiser des vidéos directement sur le site.<br><br>\
  \
  Vous pouvez personnaliser vos choix de cookies, consentir ou refuser les cookies à partir des boutons ci-dessous sauf\
  pour les cookies strictement nécessaires. Vous disposez de la possibilité de retirer votre consentement à tout moment\
  en vous rendant sur le lien <b>« gestion des cookies »</b> figurant en pied de page du site.<br><br>\
  \
  Retrouvez la liste de nos partenaires ainsi que les finalités et données collectées via ces cookies dans notre Politique\
  Cookies en vous rendant sur <b>« gestion des cookies »</b> figurant en pied de page du site.",
  "alertSmall": "Gestion des services",
  "acceptAll": "Tout autoriser",
  "personalize": "Personnaliser",
  "close": "X",

  "privacyUrl": "Politique de confidentialité",

  "all": "Préférences pour tous les services",

  "info": "Protection de votre vie privée",
  "disclaimer": "Certains cookies sont nécessaires au fonctionnement du site et ne sont pas soumis au recueil de votre consentement. Concernant les autres cookies, déposés par nous-mêmes ou nos partenaires\
  sur votre terminal, ils doivent être acceptés par vous préalablement au dépôt. Nos partenaires collecteront et utiliseront vos données de navigation pour des finalités qui leur sont propres,\
  conformément à leur politique de confidentialité (liens ci-dessous). Pour en savoir plus, <a id='cookies_policy_link' target='_blanck' href='https://www.societaires.caisse-epargne.fr/web/cookies_policy'>cliquez ici </a><br><br>\
  Votre consentement est valable uniquement pour le site sociétaires de votre Caisse d'Epargne. Vous pourrez à tout moment revenir sur vos choix, retirer votre consentement en cliquant sur la rubrique « Gestion des Cookies » présente sur chaque page du site.<br><br>\
  Vous pouvez accepter ou refuser l’ensemble des services ou les paramétrer de manière individuelle.",
  "allow": "Autoriser",
  "deny": "Refuser",
  "noCookie": "Ce service ne dépose aucun cookie.",
  "useCookie": "Ce service peut déposer",
  "useCookieCurrent": "Ce service a déposé",
  "useNoCookie": "Ce service n'a déposé aucun cookie.",
  "more": "En savoir plus",
  "source": "Voir le site officiel",
  "credit": "Gestion des cookies par tarteaucitron.js",
  "noServices": "Ce site n'utilise aucun cookie nécessitant votre consentement.",

  "toggleInfoBox": "Afficher/masquer les informations sur le stockage des cookies",
  "title": "Personnalisation des cookies",
  "cookieDetail": "Détail des cookies",
  "ourSite": "sur notre site",
  "newWindow": "(nouvelle fenêtre)",
  "allowAll": "Tout accepter",
  "denyAll": "Tout refuser",

  "icon": "Cookies",

  "fallback": "est désactivé.",

  "ads": {
      "title": "Régies publicitaires",
      "details": "Les régies publicitaires permettent de générer des revenus en commercialisant les espaces publicitaires du site."
  },
  "analytic": {
      "title": "Cookies de mesure d’audience",
      "details": "Ces cookies permettent de mesurer et analyser la fréquentation du site. Ils seront utilisés pour nous permettre de comprendre\
      la façon dont les visiteurs accèdent au site web, ainsi que les parcours réalisés. Ils nous fournissent des rapports. Par ailleurs, ils répondent à différents besoin de mesure des performances,\
      détection de problèmes de navigation, optimisation des performances techniques ou de l’ergonomie, estimation de la puissance des serveurs nécessaires, analyse des contenus consultés."
  },
  "social": {
      "title": "Réseaux sociaux",
      "details": "Les réseaux sociaux permettent d'améliorer la convivialité du site et aident à sa promotion via les partages."
  },
  "video": {
      "title": "Cookies de partage de vidéo",
      "details": "Ces cookies permettent à l’utilisateur de visualiser directement sur le site le contenu multimédia."
  },
  "comment": {
      "title": "Commentaires",
      "details": "Les gestionnaires de commentaires facilitent le dépôt de vos commentaires et luttent contre le spam."
  },
  "support": {
      "title": "Support",
      "details": "Les services de support vous permettent d'entrer en contact avec l'équipe du site et d'aider à son amélioration."
  },
  "api": {
      "title": "Cookies hCAPTCHA",
      "details": "Ces cookies permettent de lutter contre les logiciels automatiques et semis automatiques malveillants."
  },
  "other": {
      "title": "Autre",
      "details": "Services visant à afficher du contenu web."
  },

  "mandatoryTitle": "Cookies nécessaires au fonctionnement",
  "mandatoryText": "Ces cookies ont pour finalité exclusive de permettre ou faciliter la communication électronique ou qui sont strictement nécessaires\
  à la fourniture d’un service de communication en ligne à votre demande expresse. Ces cookies ne peuvent pas être désactivés,\
  et ne sont pas soumis au recueil du consentement."
  };
  tarteaucitron.init({
    "orientation":"middle",
    "removeCredit": true,
    "groupServices": true,
    "showIcon": false,
    "cookieName": "club_des_societaires_cmp"
  });

  (tarteaucitron.job = tarteaucitron.job || []).push('youtube');
  (tarteaucitron.job = tarteaucitron.job || []).push('dailymotion');
  (tarteaucitron.job = tarteaucitron.job || []).push('vimeo');
  (tarteaucitron.job = tarteaucitron.job || []).push('hcaptcha');
});
